module.exports = __webpack_public_path__ + "static/img/Banner1.7f5d107b.png";